import { createStyles, makeStyles, Theme } from "@material-ui/core";

const useRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        tableHeaderStyle: {
            background: "#007FFF",
            color: "white",
            fontSize: 12,
            fontWeight: 'bold'
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
        },
        tableCellBody: {
            color: "black",
            fontSize: "13px !important",
            padding: '2px 0px 2px 5px !important',
        },
        titleHeader: {
            fontWeight: 'bold',
            marginTop: '5px',
            color: 'white',
            fontSize: 18,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        tableBody: {
            maxHeight: 'calc( 100vh - 280px) !important',
            minHeight: 'calc( 100vh - 280px) !important',
            [theme.breakpoints.up('lg')]: {
                maxHeight: 'calc( 100vh - 280px) !important',
                minHeight: 'calc( 100vh - 280px) !important',
            },
        },
        textField: {
            // width: 240,
            alignContent: 'flex-start',
            justify: "flex-start",
            marginTop: '14px',
            '& .MuiFormControl-marginNormal': {
                marginTop: '10px'
            }
        },
        outlinedInput: {
            fontSize: 14,
            color: "black",
        },
        paper1: {
            border: "2px solid black",
        },
        autoCompleteFont: {
            fontSize: 13,
        },
        smallFont: {
            fontSize: 13,
            padding: '2px 5px'
        },
        userdropdown: {
            alignContent: 'flex-start',
            justify: "flex-start",
            display: 'flex',
            marginTop: '-4px',
        },
        dropzoneArea: {
            minHeight: '160px',
            fontSize: '12px !important',
            border: '2px dashed blue',
            backgroundColor: '#f1f5ff',
            boxShadow: 'rgba(0, 0, 0, 0.35) 3px 0px 3px 0px',
            borderRadius: '5px'
        },
        dropzoneAreaText: {
            fontSize: '18px !important',
            fontWeight: 'bold',
            color: 'blue'
        },
    })
);

export { useRowStyles };